<div class="login-container">
  <div class="login-wrapper">
    <div class="login-card">
      <!-- Brand Section -->
      <div class="login-brand">
        <div class="logo-icon">
          <img src="/images/logo.png" alt="Unplugg Software Solutions" />
        </div>
        <div class="brand-text">
          <h1>Unplugg Software Solutions</h1>
          <p>Inventory Management System</p>
        </div>
      </div>

      <!-- Welcome Section -->
      <div class="login-welcome">
        <h2>Welcome Back</h2>
        <p>Sign in to access your inventory dashboard</p>
      </div>

      <!-- Login Form -->
      <form class="login-form" (ngSubmit)="onLogin()">
        <div class="form-group">
          <label for="email">Email Address</label>
          <div class="input-wrapper">
            <i class="bi bi-envelope"></i>
            <input
              type="email"
              id="email"
              name="email"
              [(ngModel)]="email"
              placeholder="Enter your email"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-wrapper">
            <i class="bi bi-lock"></i>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              name="password"
              [(ngModel)]="password"
              placeholder="Enter your password"
              required
            />
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
              <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
            </button>
          </div>
        </div>

        <div class="form-options">
          <button type="button" class="forgot-password" (click)="onForgotPassword()">
            Forgot password?
          </button>
        </div>

        @if (showError) {
          <div class="error-message show">
            <i class="bi bi-exclamation-circle"></i>
            <span>{{ errorMessage }}</span>
          </div>
        }

        <button type="submit" class="btn-login" [disabled]="isSubmitting">
          <i class="bi bi-box-arrow-in-right"></i>
          {{ isSubmitting ? 'Sending code...' : 'Sign In' }}
        </button>
      </form>

      <!-- Footer -->
      <div class="login-footer">
        <p>&copy; 2026 Unplugg Software Solutions. All rights reserved.</p>
      </div>
    </div>

    <!-- Right Side Image/Branding -->
    <div class="login-banner">
      <div class="banner-content">
        <div class="banner-icon">
          <i class="bi bi-boxes"></i>
        </div>
        <h2>Inventory Management <br />Made Simple</h2>
        <p>Track stock, manage item rentals, maintenance, and operations across every branch — all in one place.</p>
        <div class="banner-features">
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Real-time stock tracking</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Item rental management</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Case &amp; job referencing</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Comprehensive reporting</span>
          </div>
        </div>
      </div>
      <div class="banner-footer">
        <span>Secure &bull; Reliable &bull; Professional</span>
      </div>
    </div>
  </div>
</div>